import { getRangeValues } from "../jspreadsheet/jspreadsheet";

interface Binding {
  id: string;
  type: "Table" | "Range" | "Text";
  range: string;
  worksheetIdOrName?: string;
}

// In-memory storage for bindings
const bindings = new Map<string, Binding>();

export const addBinding = async (
  id: string,
  type: "Table" | "Range" | "Text",
  range: string,
  worksheetIdOrName?: string,
) => {
  if (!id || !range) {
    throw new Error("바인딩 ID와 범위는 필수입니다.");
  }
  if (!["Table", "Range", "Text"].includes(type)) {
    throw new Error("유효하지 않은 바인딩 타입입니다.");
  }

  const binding: Binding = {
    id,
    type,
    range,
    worksheetIdOrName,
  };

  bindings.set(id, binding);
  return binding;
};

export const getBindingContent = async (
  id: string,
  _valueFormat: "text" | "raw" = "text",
): Promise<string[][]> => {
  const binding = bindings.get(id);
  if (!binding) {
    throw new Error(`Binding with id '${id}' not found`);
  }

  return getRangeValues(binding.range);
};

interface EventHandler {
  id: string;
  type: string;
  handler: Function;
  bindingId?: string;
}

// In-memory storage for event handlers
const eventHandlers = new Map<string, EventHandler>();
let eventIdCounter = 0;

export const registerBindingEvent = async (
  eventType: "onSelectionChanged" | "onDataChanged",
  handler: (event: any) => Promise<void>,
  bindingId: string,
) => {
  const id = `event_${++eventIdCounter}`;
  const eventHandler: EventHandler = {
    id,
    type: eventType,
    handler,
    bindingId,
  };

  eventHandlers.set(id, eventHandler);

  // Return a mock event result
  return {
    remove: () => {
      eventHandlers.delete(id);
    },
  };
};

export const removeBindingEvent = async (eventResult: any) => {
  if (eventResult && typeof eventResult.remove === "function") {
    eventResult.remove();
  }
};
